var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skill-progress"},[_c('p',{staticClass:"skill-name"},[_vm._v(_vm._s(_vm.skillIn.title))]),_vm._v(" "),_c('b-progress',{attrs:{"max":_vm.skillIn.max}},[_c('b-progress-bar',{attrs:{"value":_vm.skillIn.value,"label":String(_vm.skillIn.value),"variant":_vm.getVariants(),"animated":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }